const data = [
  {
    name: "Mess",
    description:
      "Ravindra Bhawan’s mess ensures that students receive nutritious and well-balanced meals every day. Known for its focus on quality, hygiene, and taste, it’s a great place to enjoy your daily meals. The mess also accepts online payments, making it easier for students to purchase coupons, especially during special occasions when they want to treat themselves. Additionally, visitors are welcome, allowing students to dine with their families whenever they visit. With a commitment to providing a comfortable dining experience, Ravindra Bhawan’s mess is open 24/7 to meet the needs of its residents. ",
    flexDirection: "row",
    vector: "diet 1.png",
    img: "mess.jpg",
  },

  {
    name: "Canteens",
    description:
      "Ravindra Bhawan offers a delightful range of food options to satisfy your cravings. With two canteens operating alternately during the day and night, students can enjoy a variety of snacks, including Maggi, samosas, sandwiches, tea, coffee, and cold drinks. The prices are set by the chief warden, ensuring that the food is both affordable and delicious, making it easy for everyone to indulge without worrying about their budget.",
    flexDirection: "row-reverse",
    vector: "restaurant 1.png",
    img: "canteen.jpg",
  },

  {
    name: "Sports Facilities",
    description:
      "At Ravindra Bhawan, we take pride in offering top-notch sports facilities for all residents. With well-maintained badminton courts and ample space for outdoor activities, you’ll never have to look elsewhere to enjoy a game. Whether you prefer a casual match or serious practice, Ravindra Bhawan provides the perfect environment for sports enthusiasts to thrive",
    flexDirection: "row",
    vector: "sports 1.png",
    img: "sports.jpg",
  },

  {
    name: "Washing Room",
    description:
      "Ravindra Bhawan emphasizes student convenience by offering a well-equipped laundry room with fully automatic washing machines. Additionally, a washerman is available every day except Sunday, free of charge, ensuring that students can manage their laundry without any hassle.",
    flexDirection: "row-reverse",
    vector: "laundry-machine 1.png",
    img: "laundry.jpg",
  },

  {
    name: "Ravindra Club",
    description:
      "Ravindra Bhawan proudly offers its own recreational space—Ravindra Club—designed for those who prefer staying closer to home instead of heading to the central student’s club. As one of the few Bhawans with its own club, it features facilities such as table tennis, carrom, chess, and a foosball table, providing students with the perfect place to relax and unwind after a busy day.",
    flexDirection: "row",
    vector: "snooker 1.png",
    img: "jbclub.JPG",
  },

  {
    name: "Guest Room",
    description:
      "Ravindra Bhawan offers the convenience of guest rooms available on demand, eliminating the need for lengthy hotel booking procedures. This is especially useful for those moments when you might forget to book a hotel amidst the busy schedule of academics, clubs, and other activities, ensuring a hassle-free stay for your guests.",
    flexDirection: "row-reverse",
    vector: "accomodation 1.png",
    img: "hero.JPG",
  },
  {
    name: "Study Room",
    description: "Ravindra Bhawan provides a dedicated study room, offering a quiet and focused environment for residents. Whether preparing for exams, working on projects, or catching up on reading, this space is perfect for uninterrupted study sessions. Equipped with all the necessary amenities, the study room ensures you can stay productive without the distractions often found in more public areas.",
    flexDirection: "row",
    vector: "studyroom.png",
    img: "study_room.jpg",
  },

  {
    name: "Gymnasium",
    description:
      "Fitness enthusiast? Ravindra Bhawan has you covered. With a fully equipped gym open to all students, you’ll have access to top-quality machines and equipment, all regularly maintained. Whether you're continuing your fitness journey or just getting started, our gym provides the perfect environment to stay active and healthy.",
    flexDirection: "row-reverse",
    vector: "weights 1.png",
    img: "GYM.jpg",
  },
  {
    name: "Barber/ Tailor",
    description:
      "Ravindra Bhawan ensures that basic amenities are easily accessible, including a barber and tailor. With student-friendly timings, you'll have convenient access to these services, making sure you’re never caught off guard when you need a trim or clothing alterations.",
    flexDirection: "row",
    vector: "tools.png",
    img: "barber.jpg",
  },
  {
    name: "Stationary",
    description:
      "Ravindra Bhawan also provides a stationary shop for all your academic and personal needs. With convenient timings, you’ll always have easy access to stationery essentials, ensuring you’re well-prepared for your studies and daily activities.",
    flexDirection: "row-reverse",
    vector: "stationary.png",
    img: "stationary.jpg",
  },
  {
    name: "Fruit Shop",
    description:
      "Ravindra Bhawan is unique as one of the few Bhawans—and the only one for undergraduates—with its own fruit shop. This allows you to conveniently get your daily dose of nutritious fruits at reasonable prices, right within the Bhawan.",
    flexDirection: "row",
    vector: "vegetables.png",
    img: "fruitShop.jpg",
  },
];

export default data;
